import GloveIcon from "./GloveIcon";
export default GloveIcon;
